<!-- appointment click on status && census status-->
<template>
    <div>
        <b-modal
            id="statusModal"
            ref="statusModal"
            :lazy="true"
            :scrollable="true"
            :title="title"
            title-tag="h2"
            no-close-on-backdrop
            @shown="shown"
            @hidden="close"
            :hide-header-close="
                saving && _.get($refs, 'checkout.is_cc_terminal')
            "
        >
            <div v-if="warningMessagePayment && disableButton">
                <div class="alert-wrapper">
                    <div
                        class="alert alert-warning alert-dismissible"
                        role="alert"
                    >
                        {{ warningMessagePayment }}
                    </div>
                </div>
            </div>

            <b-alert
                show
                variant="warning"
                v-if="
                    appointment_data.isDefaultProvider &&
                    appointment_data.bundle_id.length > 0
                "
            >
                <span id="dialog-alert-message">
                    {{ CLINIC_PROVIDER_ALERT.LAB_RADIOLOGY_BUNDLE }}
                </span>
            </b-alert>
            <!-- Modal Form -->
            <div class="pl-2">
                <b-form-group
                    v-if="page != 'bundle'"
                    :label-cols="
                        page == 'checkout' && $refs.checkout
                            ? $refs.checkout.col
                            : 3
                    "
                    :label-for="`census_status`"
                    label="Status:"
                >
                    <select
                        id="census_status"
                        v-model="status"
                        :disabled="loading"
                        class="form-control col"
                    >
                        <option
                            v-for="status in availableStatus"
                            :key="status.id"
                            :value="status.index"
                            >{{ status.value }}</option
                        >
                    </select>
                </b-form-group>
                <b-form-group
                    :label-for="`census_date`"
                    v-if="status == 2"
                    label="Date:"
                    label-cols="3"
                >
                    <vet-datetime
                        v-model="census_date"
                        v-validate="'required'"
                        :placeholder="{
                            date: 'Confirmed Date (required)',
                            time: 'Confirmed Time (required)'
                        }"
                        container="#statusModal"
                        name="census_date"
                        rules="required"
                        format="moment"
                    ></vet-datetime>
                </b-form-group>
                <b-form-group
                    v-if="status == 5"
                    :label-for="`census_room`"
                    label="Room:"
                    label-cols="3"
                >
                    <select
                        id="census_room"
                        v-model="room"
                        :class="{ 'border-danger': errors.has('census_room') }"
                        v-validate="'excluded:0'"
                        class="form-control col"
                        name="census_room"
                    >
                        <option value="0">Select room (required)</option>
                        <option
                            v-for="room in rooms"
                            :key="room.id"
                            :value="room.id"
                            >{{ room.name }}</option
                        >
                    </select>
                </b-form-group>
                <b-form-group
                    v-if="status == 3"
                    :label-for="`reason`"
                    label="Reason:"
                    label-cols="3"
                >
                    <select
                        id="reason"
                        v-model="cancellation_reason"
                        class="form-control col"
                    >
                        <option
                            v-for="reason in cancellation_reasons"
                            :key="reason.id"
                            :value="reason.id"
                            >{{ reason.name }}</option
                        >
                    </select>
                </b-form-group>
                <div
                    v-if="
                        status == APPOINTMENT.STATUS_CHECKED_IN &&
                        appointmentStatus.id !=
                            APPOINTMENT.STATUS_VISIT_COMPLETE
                    "
                >
                    <check-in
                        ref="checkInForm"
                        v-show="page == 'checkin'"
                        :page="page"
                        :data="appointment_data"
                        @loading="loading = true"
                        @loaded="loading = false"
                    />
                    <bundle
                        ref="bundle"
                        v-show="page == 'bundle'"
                        :data="bundle_data"
                        :app-data="appointment_data"
                        :isEstimate="isEstimate"
                        @loading="loading = true"
                        @loaded="loading = false"
                        class="pl-2"
                    />
                </div>
                <!--
                    GIT #3272
                    If old status is "Visit Complete", don't process check in when changing status
                    this is because the appointment was already checked in previously
                 -->
                <div
                    v-if="
                        status == APPOINTMENT.STATUS_CHECKED_IN &&
                        (disableCheckInForm || preSelectStatus)
                    "
                >
                    <b-form-group
                        :label-for="`census_notes`"
                        label="Notes:"
                        label-cols="3"
                    >
                        <editable
                            id="census_notes"
                            v-model="note"
                            placeholder="Notes (optional)"
                            rows="3"
                            :defaultHeight="64"
                        ></editable>
                    </b-form-group>
                </div>
                <div v-if="status == APPOINTMENT.STATUS_CHECKED_OUT">
                    <check-out
                        ref="checkout"
                        v-show="page == 'checkout'"
                        :currentPage="page"
                        :data="checkout_data"
                        :app-data="appointment_data"
                        @loading="loading = true"
                        @loaded="loading = false"
                    />
                    <payment
                        v-if="page == 'payment'"
                        ref="payment"
                        v-show="page == 'payment'"
                        :data="checkout_data"
                        :metadata="metadata"
                        :app-data="appointment_data"
                        @loading="loading = true"
                        @loaded="loading = false"
                        @save="verifyGravityPayment"
                        @disableSaveButton="disabledSaveButton"
                    />
                </div>
                <b-form-group
                    v-if="_.includes([1, 2, 3, 5, 6], status)"
                    :label-for="`census_notes`"
                    label="Notes:"
                    label-cols="3"
                >
                    <editable
                        id="census_notes"
                        v-model="note"
                        placeholder="Notes (optional)"
                        rows="3"
                        :defaultHeight="64"
                    ></editable>
                </b-form-group>
            </div>
            <div id="footer-work" slot="modal-footer" class="w-100">
                <b-button
                    @click="$refs.statusModal.hide()"
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div v-if="loading">
                    <b-btn
                        v-if="
                            _.get(
                                checkout_data,
                                'payment_type_object.name',
                                ''
                            ) == 'Credit Card On Terminal (Gravity)' &&
                            saving &&
                            !cancelling
                        "
                        class="float-left"
                        variant="secondary"
                        @click="cancelOperation"
                        >Cancel
                    </b-btn>
                    <b-btn
                        v-if="
                            _.get(
                                checkout_data,
                                'payment_type_object.name',
                                ''
                            ) == 'Credit Card On Terminal (Stripe)' &&
                            saving &&
                            !cancelling &&
                            stripeTerminal !== null
                        "
                        class="float-left"
                        variant="secondary"
                        @click="resetStripeTerminal"
                        >Cancel
                    </b-btn>
                    <div class="float-right" style="margin-top: 0.5rem;">
                        <span
                            v-if="
                                _.get($refs, 'checkout.is_cc_terminal') &&
                                saving &&
                                !cancelling
                            "
                            >Processing payment</span
                        >
                        <span
                            v-if="
                                _.get($refs, 'checkout.is_cc_terminal') &&
                                cancelling
                            "
                            >Cancelling</span
                        >
                        <img class="float-right" src="assets/ajax-loader.gif" />
                    </div>
                </div>

                <!-- Checkin -->
                <div
                    v-else-if="status == 4 && !disableCheckInForm"
                    class="float-right"
                >
                    <b-btn
                        @click="backCheckin"
                        v-if="page == 'bundle'"
                        variant="primary"
                        >Back</b-btn
                    >&nbsp;
                    <b-btn
                        @click="nextCheckin"
                        v-if="isBundle && page == 'checkin' && !isAdmit"
                        variant="primary"
                        >Next</b-btn
                    >
                    <b-button
                        v-else
                        :disabled="
                            page == 'bundle' &&
                            bundle_data.selectedElements.length === 0
                        "
                        variant="primary"
                        @click="save(id)"
                        >{{
                            page === "checkin" && isAdmit && isStartTreatment
                                ? "Save + Start Treatment"
                                : "Save"
                        }}</b-button
                    >
                </div>

                <!-- Checkout -->
                <div v-else-if="status == 7" class="float-right">
                    <b-btn
                        @click="backCheckout"
                        v-if="page != 'checkout'"
                        variant="primary"
                        >Back</b-btn
                    >&nbsp;
                    <b-btn
                        @click="nextCheckout"
                        v-if="
                            page == 'checkout' &&
                            _.get($refs, 'checkout.is_cc_key_in')
                        "
                        variant="primary"
                        :disabled="disableButton"
                        >Next</b-btn
                    >
                    <b-btn
                        @click="showCreditCardDialog"
                        v-else-if="
                            page == 'checkout' &&
                            _.get($refs, 'checkout.is_cc_card_in')
                        "
                        variant="primary"
                        :disabled="disableButton"
                        >Next</b-btn
                    >
                    <b-btn
                        v-else-if="
                            page == 'payment' &&
                            _.get($refs, 'checkout.is_gravity_key_in')
                        "
                        variant="primary"
                        id="save-btn"
                        >Check Out</b-btn
                    >
                    <b-btn
                        v-else-if="page == 'payment'"
                        variant="primary"
                        :disabled="isDisabledButton || disableButton"
                        @click="saveCreditCard"
                        >Check Out</b-btn
                    >
                    <b-btn
                        v-else
                        :disabled="
                            (_.get($refs, 'checkout.is_cc_terminal') &&
                                _.get($refs, 'checkout.is_no_terminal')) ||
                            disableButton
                        "
                        variant="primary"
                        @click="save"
                        >Check Out</b-btn
                    >
                </div>

                <div v-else class="float-right">
                    <b-button
                        @click="save(id)"
                        variant="primary"
                        :disabled="disableButton"
                        >Save</b-button
                    >
                </div>
            </div>
        </b-modal>
        <multipleRequisitionForm ref="multipleRequisitionFormWindow" />
        <notifications
            v-if="status == APPOINTMENT.STATUS_CHECKED_IN"
            group="change-status"
        >
            <template slot="body" slot-scope="props">
                <div class="vue-notification-template vue-notification">
                    <div class="notification-title">
                        {{ props.item.title }}
                        <a @click="props.close" class="close">&times;</a>
                    </div>
                    <div class="notification-content">
                        <ol>
                            <li
                                v-for="client in notification.client"
                                :key="client.id"
                            >
                                {{ client.content }}
                            </li>
                            <li
                                v-for="patient in notification.patient"
                                :key="patient.id"
                            >
                                {{ patient.content }}
                            </li>
                        </ol>
                    </div>
                </div>
            </template>
        </notifications>
        <StartTreatment ref="startTreatment" />
    </div>
</template>
<script>
import ScheduleHelper from "@/module/schedule/helper";
import vetDatetime from "@/module/commons/date-time-picker.vue";
import CheckIn from "./check-in/check-in.vue";
import Bundle from "@/module/commons/bundle/bundle";
import CheckOut from "./check-out/check-out.vue";
// import Payment from "./payment.vue";
import { some, filter, get, merge, clone, cloneDeep, map, find } from "lodash";
import Payment from "@/module/payment/payment.vue";
import MultipleRequisitionForm from "@/module/commons/print_multiple_requisition_form.vue";
import PaymentDialogHelper from "@/module/payment/helper.js";
import CensusMixin from "@/mixins/census";
import LabMixin from "@/mixins/lab";
import CLINICPROVIDER from "@/constants/clinic-provider";
import PaymentService from "@/services/payment.js";
import PaymentInvoiceSocketMixin from "@/mixins/payment-invoice-socket";
import StartTreatment from "@/module/schedule/treatment-board/start";
import Editable from "@/components/elements/editable-textarea";
import unsavePrompt from "@/mixins/unsave-prompt.js";

export default {
    name: "StatusUpdater",
    components: {
        CheckIn,
        Bundle,
        CheckOut,
        Payment,
        vetDatetime,
        MultipleRequisitionForm,
        StartTreatment,
        Editable
    },
    mixins: [
        ScheduleHelper,
        PaymentDialogHelper,
        CensusMixin,
        LabMixin,
        PaymentInvoiceSocketMixin,
        unsavePrompt
    ],
    props: {
        instanceId: {
            type: String,
            default: null
        },
        invoiceId: {
            type: String,
            default: null
        },
        refreshAll: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            // -- incase of same status but multiple page. use this {page}. Otherwise keep it null
            title: "Change Status",
            page: null,
            id: null,
            loading: false,
            saving: false,
            cancelling: false,
            rooms: [],
            cancellation_reasons: [],
            census_date: moment(),
            status: 0,
            room: 0,
            cancellation_reason: 0,
            note: null,
            showBundle: false,
            disableCheckInForm: false,
            isDisabledButton: false,
            appointment_data: {
                id: null,
                start: null,
                end: null,
                client: null,
                client_id: null,
                reason: "",
                patient: null,
                patient_id: null,
                note: "",
                staff_id: null,
                soap_id: 0,
                type: 1,
                repeat: 1,
                referrer: null,
                occurence: 1,
                location: null,
                appointmentType: null,
                status_id: 1,
                letter_ids: [],
                webforms: [],
                bundle_id: "",
                single_bundle_id: "",
                bill_to_invoice: -3,
                print_card: false,
                print_quantity: 1,
                weight: 0,
                uom: 75,
                admit: false,
                isDefaultProvider: false,
                mobileCountryCode: null,
                mobile: null,
                communicationType: 0,
                isUpdateClientContact: false,
                startTreatment: false,
                send_pre_visit: false,
                pre_visit_send: false,
                pre_visit_send_at: null
            },
            open_time: null,
            checkout_data: {
                id: null,
                checkout_date: null,
                invoicesList: [],
                appointment_checked_in: null,
                client_id: null,
                client_email: null,
                client_fax: null,
                credit_amount: 0,
                credits: null,
                creditsList: [],
                currency_symbol: null,
                documents: [],
                documentsList: [],
                export_message: null,
                invoice_amount: 0,
                invoices: [],
                outstanding_amount: 0,
                payment_amount: 0,
                patient_id: null,
                provider_id: null,
                rabies: {
                    tag: null,
                    record_id: null
                },
                reminder_message: "",
                reminder_note: "",
                payment_type: -1,
                payment_type_object: {},
                paymentTypes: [],
                credit_card_name_on_card: "",
                credit_card_card_number: "",
                credit_card_expiry_month: "",
                credit_card_expiry_year: "",
                credit_card_ccv: "",
                credit_card_processor: "",
                year_options: [],
                save_card: 0,
                anet_transaction_id: "",
                anet_transaction_output: "",
                anet_transaction_name: "",
                payment_id: "",
                terminal: 0,
                terminals: [],
                payment_method_name: null,
                show_payment_form: 0,
                export_type: 0,
                change: 0,
                status: 7,
                signature_cc: null,
                checkout_uid: null,
                modalWindow: "#statusModal",
                cardconnect_iframe_url: null,
                cc_iframe_load: false,
                giframe_load: false,
                external_id: "",
                isSimulator: 0,
                testCardNumber: ""
            },
            bundle_data: {
                bundle_id: null,
                selectedElements: [],
                elements: []
            },
            appointmentStatus: {},
            notification: {
                client: [],
                patient: []
            },
            isBundle: false,
            stripeTerminal: null,
            preSelectStatus: null,
            availableStatus: [],
            CLINIC_PROVIDER_ALERT: CLINICPROVIDER.CLINIC_PROVIDER_ALERT,
            uniqueId: null,
            start_treatment_data: {
                patient: {},
                treatment: {},
                clientID: "",
                treatmentID: ""
            },
            metadata: {},
            currentScrollY: null,
            isProcessing: false
        };
    },
    created() {
        this.$root.$on(
            "stripe-reset-terminal-schedule-checkout",
            this.cancelStripeCollectionStatus
        );
        this.$root.$on(
            "capturing-stripe-terminal-payment-schedule-checkout",
            this.capturingStripeTerminalStatus
        );
    },
    computed: {
        isEstimate() {
            return (
                this.appointment_data.bill_to_invoice &&
                (this.appointment_data.bill_to_invoice === -2 ||
                    this.appointment_data.bill_to_invoice.type === -2)
            );
        },
        isAdmit() {
            return this.appointment_data.admit;
        },
        /**
         * Translate index and module name to tbl_status id
         * @return {Object} status object.
         */
        statuses() {
            return some(this.$store.state.status)
                ? filter(this.$store.state.status, {
                      module_name: "schedule.appointment"
                  })
                : [];
        },
        hasNotification() {
            return (
                this.notification.patient.length ||
                this.notification.client.length
            );
        },
        disableButton() {
            return (
                this.warningMessagePayment !== "" &&
                this.status === this.APPOINTMENT.STATUS_CHECKED_OUT
            );
        },
        warningMessagePayment() {
            // VET-6975 - The warning message on will be shown if the invoice been selected and checkout from the invoice page
            // From other page will be handled on other ticket (VET-6981)
            if (this.invoiceId) {
                const isInvoiceSelectedInSelectedInvoices = this.checkout_data.invoices.find(
                    invoice => invoice.id === this.invoiceId
                );
                if (isInvoiceSelectedInSelectedInvoices) {
                    return this.$store.getters["billing/warningMessagePayment"](
                        this.invoiceId
                    );
                }
            }
            return "";
        },
        isStartTreatment() {
            return this.isAdmit && this.appointment_data.startTreatment;
        },
        form_dirty() {
            return this.isProcessing;
        }
    },
    watch: {
        status(newValue) {
            let self = this;
            this.open_time = moment().tz(this._timeZone);
            this.disableCheckInForm = false;
            switch (newValue) {
                case self.APPOINTMENT.STATUS_CHECKED_IN:
                    if (self.$refs.checkInForm) {
                        self.$refs.checkInForm.$validator.reset();
                    }
                    this.page = "checkin";

                    /**
                     * get client & patient notes when status changed to Checked In
                     */
                    this.notification.client = [];
                    if (this.appointment_data.client_id) {
                        this.clientNotes(this.appointment_data.client_id);
                    }
                    this.notification.patient = [];
                    if (this.appointment_data.patient_id) {
                        this.patientNotes(this.appointment_data.patient_id);
                    }
                    break;
                case self.APPOINTMENT.STATUS_CHECKED_OUT:
                    if (self.$refs["checkout"]) {
                        self.$refs["checkout"].$validator.reset();
                    }
                    self.getCiCheckOut(self.appointment_data.id);
                    self._getPaymentTypes(this.checkout_data);
                    self._getTerminals(this.checkout_data);
                    this.checkout_data.checkout_date = this.open_time;
                    this.checkout_data.is_census = true;
                    this.page = "checkout";
                    break;
                case self.APPOINTMENT.STATUS_IN_ROOM:
                    this.loading = true;
                    this.getRooms().finally(() => (this.loading = false));
                    break;
                case self.APPOINTMENT.STATUS_CANCELLED:
                    this.loading = true;
                    self._getCancellationReasonOptions()
                        .then(response => {
                            self.cancellation_reasons = response;
                            self.cancellation_reason =
                                self.cancellation_reasons[0].id;
                        })
                        .finally(() => (this.loading = false));
                    break;

                default:
                    this.page = null;
                    break;
            }
        },
        "data.admit"(value) {
            if (value) {
                this.bundle_data = {
                    bundle_id: null,
                    selectedElements: [],
                    elements: []
                };
            }
        },
        "appointment_data.client_id"(value) {
            this.notification.client = [];
            if (value && this.status === this.APPOINTMENT.STATUS_CHECKED_IN) {
                this.clientNotes(value);
            }
        },
        "appointment_data.patient_id"(value) {
            this.notification.patient = [];
            if (value && this.status === this.APPOINTMENT.STATUS_CHECKED_IN) {
                this.patientNotes(value);
            }
        },
        hasNotification(value) {
            if (value) {
                this.popupNotification();
            } else {
                this.$notify({
                    group: "change-status",
                    clean: true
                });
            }
        },
        "appointment_data.bundle_id"(value) {
            if (value && value.length > 0) {
                this.isBundle = true;
            } else {
                this.isBundle = false;
            }
        }
    },
    methods: {
        shown() {
            this.uniqueId = this.uniqid();
            this.checkout_data.uniqueId = this.uniqueId;
            this.registerSocketHandling();
        },
        close() {
            this.unregisterSocketHandling();
        },
        registerSocketHandling() {
            let self = this;

            this.$socket.client.on("v-broadcast-all", params => {
                self._socketPostPayment({
                    params: params,
                    uniqueId: self.uniqueId,
                    onSuccess() {
                        self.$refs.statusModal.hide();
                        if (self.refreshAll) {
                            self.$parent.refetch();
                        }

                        // Emit socket to refresh census
                        const payload = {
                            appointmentDate: self
                                ._toDateTime(self.appointment_data?.start)
                                .toSeconds(),
                            appointmentId: self.appointment_data?.id,
                            instanceId: self.instanceId
                        };

                        self.refreshCensus(payload);

                        if (
                            self.status === self.APPOINTMENT.STATUS_CHECKED_IN
                        ) {
                            self._message(
                                "Appointment successfully checked in"
                            );
                        } else if (
                            self.status === self.APPOINTMENT.STATUS_CHECKED_OUT
                        ) {
                            self._message(
                                "Appointment successfully checked out"
                            );
                        } else {
                            self._message(params.message);
                        }
                        window.removeEventListener("beforeunload", null);
                    },
                    onError(msg) {
                        window.removeEventListener("beforeunload", null);
                        self._message(msg, "warning");
                        self.saving = false;
                        self.loading = false;
                        self.cancelling = false;
                    }
                });
            });
        },
        unregisterSocketHandling() {
            this.$socket.client.off("v-broadcast-all");
        },
        renderAvailableStatus() {
            let filterStatus = [];
            let result = [];
            if (
                !(
                    this.statuses.length &&
                    this.appointmentStatus &&
                    this.appointmentStatus.index
                )
            ) {
                return [];
            }
            switch (this.appointmentStatus.id) {
                case this.APPOINTMENT.STATUS_NOT_CONFIRMED:
                    filterStatus = [
                        this.APPOINTMENT.STATUS_NOT_CONFIRMED,
                        this.APPOINTMENT.STATUS_CONFIRMED
                    ];

                    if (this._hasAccess("schedule.appointment.delete")) {
                        filterStatus.push(this.APPOINTMENT.STATUS_CANCELLED);
                    }

                    if (this._hasAccess("schedule.appointment.checkin")) {
                        filterStatus.push(this.APPOINTMENT.STATUS_CHECKED_IN);
                    }

                    break;
                case this.APPOINTMENT.STATUS_CONFIRMED:
                    filterStatus = [this.APPOINTMENT.STATUS_NOT_CONFIRMED];

                    if (this._hasAccess("schedule.appointment.delete")) {
                        filterStatus.push(this.APPOINTMENT.STATUS_CANCELLED);
                    }

                    if (this._hasAccess("schedule.appointment.checkin")) {
                        filterStatus.push(this.APPOINTMENT.STATUS_CHECKED_IN);
                    }
                    break;

                case this.APPOINTMENT.STATUS_PREVISIT:
                    filterStatus = [
                        this.APPOINTMENT.STATUS_NOT_CONFIRMED,
                        this.APPOINTMENT.STATUS_CONFIRMED
                    ];

                    if (this._hasAccess("schedule.appointment.delete")) {
                        filterStatus.push(this.APPOINTMENT.STATUS_CANCELLED);
                    }

                    if (this._hasAccess("schedule.appointment.checkin")) {
                        filterStatus.push(this.APPOINTMENT.STATUS_CHECKED_IN);
                    }
                    break;

                case this.APPOINTMENT.STATUS_CHECKED_IN:
                    filterStatus = [
                        this.APPOINTMENT.STATUS_IN_ROOM,
                        this.APPOINTMENT.STATUS_VISIT_COMPLETE
                    ];

                    if (this._hasAccess("schedule.appointment.checkout")) {
                        filterStatus.push(this.APPOINTMENT.STATUS_CHECKED_OUT);
                    }

                    break;
                case this.APPOINTMENT.STATUS_CANCELLED:
                    filterStatus = [
                        this.APPOINTMENT.STATUS_NOT_CONFIRMED,
                        this.APPOINTMENT.STATUS_CONFIRMED
                    ];

                    break;
                case this.APPOINTMENT.STATUS_VISIT_COMPLETE:
                    filterStatus = [this.APPOINTMENT.STATUS_IN_ROOM];

                    if (this._hasAccess("schedule.appointment.checkin")) {
                        filterStatus.push(this.APPOINTMENT.STATUS_CHECKED_IN);
                    }

                    if (this._hasAccess("schedule.appointment.checkout")) {
                        filterStatus.push(this.APPOINTMENT.STATUS_CHECKED_OUT);
                    }
                    break;
                case this.APPOINTMENT.STATUS_IN_ROOM:
                    filterStatus = [
                        this.APPOINTMENT.STATUS_IN_ROOM,
                        this.APPOINTMENT.STATUS_VISIT_COMPLETE
                    ];

                    if (this._hasAccess("schedule.appointment.checkout")) {
                        filterStatus.push(this.APPOINTMENT.STATUS_CHECKED_OUT);
                    }
                    break;
                case this.APPOINTMENT.STATUS_CHECKED_OUT:
                default:
                    filterStatus = [
                        this.APPOINTMENT.STATUS_NOT_CONFIRMED,
                        this.APPOINTMENT.STATUS_CONFIRMED,
                        this.APPOINTMENT.STATUS_IN_ROOM,
                        this.APPOINTMENT.STATUS_VISIT_COMPLETE,
                        this.APPOINTMENT.STATUS_UNCONFIRMED_OL,
                        this.APPOINTMENT.STATUS_REJECTED
                    ];

                    if (this._hasAccess("schedule.appointment.delete")) {
                        filterStatus.push(this.APPOINTMENT.STATUS_CANCELLED);
                    }

                    if (this._hasAccess("schedule.appointment.checkin")) {
                        filterStatus.push(this.APPOINTMENT.STATUS_CHECKED_IN);
                    }

                    if (this._hasAccess("schedule.appointment.checkout")) {
                        filterStatus.push(this.APPOINTMENT.STATUS_CHECKED_OUT);
                    }
                    break;
            }
            result = _(this.statuses).keyBy("index").at(filterStatus).value();

            if (
                this.appointmentStatus.index !==
                    this.APPOINTMENT.STATUS_IN_ROOM ||
                this.preSelectStatus
            ) {
                this.finishedComputed(result);
            }

            this.availableStatus = result;
        },
        popupNotification() {
            this.$notify({
                group: "change-status",
                clean: true
            });
            if (
                this.notification.client.length ||
                this.notification.patient.length
            ) {
                this.$notify({
                    group: "change-status",
                    title: "ATTENTION",
                    duration: -1,
                    closeOnClick: false
                });
            }
        },
        patientNotes(id) {
            let self = this;
            return self.$http
                .get(process.env.BARRACUDA + "patient/" + id + "/popup-notes")
                .then(function (response) {
                    self.notification.patient = response.data.response.resource;
                });
        },
        clientNotes(id) {
            let self = this;
            return self.$http
                .get(
                    process.env.ACTOR_SERVICE + "client/" + id + "/popup-notes"
                )
                .then(function (response) {
                    self.notification.client = response.data.response.resource;
                });
        },
        //checkout buttons start
        nextCheckout() {
            let self = this;
            if (self.page === "checkout") {
                self.$refs.checkout.$validator.validateAll().then(result => {
                    if (result) {
                        self.checkout_data.show_payment_form = 1;
                        self.checkout_data.credit_card_name_on_card = get(
                            self,
                            "appointment_data.client.label"
                        );
                        self.page = "payment";

                        self.metadata = _.merge(
                            {},
                            self.checkout_data,
                            self.$refs.checkout.getParams()
                        );

                        if (
                            self.checkout_data.credit_card_processor ===
                                "CCONNECT" &&
                            !self.checkout_data.cc_iframe_load
                        ) {
                            self.loading = true;
                        }
                    }
                });
            }
        },
        nextCheckin() {
            let self = this;
            self.$refs.checkInForm.$validator.validateAll().then(result => {
                if (result) {
                    self.bundle_data.bundle_id =
                        self.appointment_data.bundle_id;

                    self.page = "bundle";
                    self.title = "New Bundle";
                    self.$refs.bundle.getCiBundle();

                    $(".modal-content").removeAttr("tabindex");
                }
            });
        },
        showCreditCardDialog() {
            let self = this;
            if (self.page === "checkout") {
                self.$refs.checkout.$validator.validateAll().then(result => {
                    if (result) {
                        self.checkout_data.show_payment_form = 0;
                        self.page = "payment";
                    }
                });
            }
        },
        async saveCreditCard() {
            let self = this;
            self.loading = true;
            self.isProcessing = true;
            if (!window.paymentProcessingBanner) {
                self.showPaymentProcessingMessage();
            }

            const save_card = self.checkout_data.save_card == 1;
            if (
                save_card &&
                this.checkout_data.credit_card_processor === "STRIPE"
            ) {
                try {
                    let updateMetadata = await PaymentService.updateSaveCard(
                        self.checkout_data.stripe.clientSecret.split(
                            "_secret"
                        )[0],
                        {
                            input_metadata: {
                                save_card: save_card
                            }
                        }
                    );
                    if (updateMetadata.code !== 200) {
                        self._message("Failed to save card", "danger");
                        self.loading = false;
                        self.saving = false;
                        return;
                    }
                } catch (error) {
                    self._message("Failed to save card", "danger");
                    self.loading = false;
                    self.saving = false;
                    return;
                }
            }
            return self.$refs.payment
                .pay_checkout(self.checkout_data)
                .then(response => {
                    if (response && response.state !== 1) {
                        self.save(response);
                    } else {
                        self.loading = false;
                        self.isProcessing = false;
                        self.closePaymentProcessingMessage();
                        return response;
                    }
                })
                .finally(() => {
                    // self.loading = false;
                });
        },
        backCheckout() {
            if (this.page === "payment") {
                this.page = "checkout";
                this.title = "Change Status";
            }
        },
        backCheckin() {
            if (this.page === "bundle") {
                this.page = "checkin";
                this.title = "Change Status";
            }
        },
        //checkout buttons end
        getCiCheckOut(appointment_id) {
            let self = this;
            self.loading = true;
            $.get(
                process.env.APPS +
                    "index.php/schedule/census/prepareCheckoutData?id=" +
                    appointment_id
            )
                .then(function (response) {
                    self.checkout_data.invoicesList = [];
                    self.checkout_data.invoices = [];
                    self.checkout_data.creditsList = [];
                    self.checkout_data.credits = [];
                    self.checkout_data.documentsList = [];
                    self.checkout_data.documents = [];

                    self.checkout_data = merge(
                        self.checkout_data,
                        response.form_data
                    );

                    if (self.checkout_data.invoices) {
                        self.checkout_data.invoicesList = Object.entries(
                            self.checkout_data.invoices
                        ).map(([id, label]) => ({
                            id,
                            label,
                            is_invoice: true
                        }));
                        self.checkout_data.invoices = clone(
                            self.checkout_data.invoicesList
                        );
                    }
                    if (self.checkout_data.credits) {
                        self.checkout_data.creditsList = Object.entries(
                            self.checkout_data.credits
                        ).map(([id, label]) => ({ id, label }));
                        self.checkout_data.credits = clone(
                            self.checkout_data.creditsList
                        );
                    }
                    if (self.checkout_data.documents) {
                        self.checkout_data.documentsList = Object.entries(
                            self.checkout_data.documents
                        ).map(([id, label]) => ({ id, label }));

                        const params = {
                            dataDefaultDocuments:
                                self.checkout_data.default_documents,
                            dataDocumentList: self.checkout_data.documentsList,
                            dataDocuments: self.checkout_data.documents
                        };

                        self.checkout_data.documents = self.checkoutDefaultDocuments(
                            params
                        );
                    }
                    if (this.$refs.checkout) {
                        this.$refs.checkout.emitSocketInvoiceChanged(); // The function is in payment-modal.js to trigger the socket payment invoice
                    }
                })
                .always(() => (self.loading = false));
        },
        getRooms() {
            let self = this;
            return this.$http
                .get(process.env.SCHEDULE_SERVICE + "rooms")
                .then(function (response) {
                    self.rooms = response.data.response.resources;
                });
        },
        finishedComputed(result) {
            let self = this;
            if (result.length) {
                self.status = result[0].index;
                self.setPreSelectStatus(result);
            }
        },
        async open(data) {
            let self = this;
            let promise = [];
            this.loading = true;
            this.id = data.id;
            this.appointment_data = merge(self.appointment_data, data);
            this.appointmentStatus = data.appointmentStatus;
            this.preSelectStatus = data.preSelectStatus;

            this.checkout_data.checkout_uid = this.uniqid();

            let resource = await this._getAppointment(data.id, {
                with_cancelled: true
            });

            self.appointment_data = merge(self.appointment_data, resource);

            self.appointmentStatus = resource.appointmentStatus;
            self.appointment_data.location_id = 0;
            self.appointment_data.location = null;
            self.appointment_data.weight = 0;
            self.appointment_data.uom = 75;
            self.appointment_data.bundle_id = "";
            self.appointment_data.print_quantity = 1;
            if (
                get(self, "appointmentStatus.index") ===
                self.APPOINTMENT.STATUS_IN_ROOM
            ) {
                self.status = self.appointmentStatus.index;

                self.room = get(self, "appointmentStatus.pivot.room_id");
            }

            await self.renderAvailableStatus();

            self.loading = false;
            self.$refs.statusModal.show();
        },
        setPreSelectStatus(options) {
            if (this.preSelectStatus) {
                let selStatus = find(
                    options,
                    obj => obj.id == this.preSelectStatus
                );

                // if not found, means the user dont have any permission to do the action hence, no option for that action
                if (selStatus) {
                    this.status = selStatus.index;
                }
            }
        },
        async save(status_data) {
            let self = this;
            self.currentScrollY = window.scrollY;
            let promise = null;
            self.saving = true;
            self.cancelling = false;
            this.loading = true;
            self.isProcessing = true;
            if (!window.paymentProcessingBanner) {
                self.showPaymentProcessingMessage();
            }

            if (
                this.status === this.APPOINTMENT.STATUS_IN_ROOM ||
                this.status === this.APPOINTMENT.STATUS_CONFIRMED ||
                (this.status === this.APPOINTMENT.STATUS_CHECKED_IN &&
                    this.appointmentStatus.id ==
                        this.APPOINTMENT.STATUS_VISIT_COMPLETE)
            ) {
                promise = self.$validator.validateAll();
            } else {
                if (self.page === "checkout") {
                    promise = self.$refs.checkout.$validator.validateAll();
                } else if (self.page === "payment") {
                    promise = self.$refs.payment.$validator.validateAll();
                } else if (self.page === "bundle") {
                    promise = self.$refs.bundle.$validator.validateAll();
                } else if (self.page === "checkin") {
                    promise = self.$refs.checkInForm.$validator.validateAll();
                } else {
                    promise = Promise.resolve(true); // -- empty promise
                }
            }

            let params = cloneDeep(this.appointment_data);

            switch (this.status) {
                case this.APPOINTMENT.STATUS_NOT_CONFIRMED:
                    params.confirmed_date = this.census_date;
                    params.confirmed_time = this.census_date;
                    params.note = this.note;
                    break;
                case this.APPOINTMENT.STATUS_CONFIRMED:
                    params.confirmed_date = this.census_date;
                    params.confirmed_time = this.census_date;
                    params.note = this.note;
                    break;
                case this.APPOINTMENT.STATUS_CANCELLED:
                    params.from_census = true;
                    params.reason_id = this.cancellation_reason;
                    params.note = this.note;
                    break;
                case this.APPOINTMENT.STATUS_CHECKED_IN:
                    // -- checked in status (please add check in params here)
                    if (
                        this.appointmentStatus.id !=
                        this.APPOINTMENT.STATUS_VISIT_COMPLETE
                    ) {
                        params.provider_id = params.staff_id;
                        params = merge(params, this.bundle_data);
                    } else {
                        params.note = this.note;
                    }
                    break;
                case this.APPOINTMENT.STATUS_IN_ROOM:
                    params.room_id = this.room;
                    params.note = this.note;
                    break;
                case this.APPOINTMENT.STATUS_VISIT_COMPLETE:
                    params.note = this.note;
                    break;
                case this.APPOINTMENT.STATUS_CHECKED_OUT:
                    params = merge(
                        {},
                        status_data,
                        self.$refs.checkout.getParams()
                    );
                    params.unique_id = this.uniqueId;

                    $(window).on("beforeunload", function () {
                        return "Are you sure you want to leave?";
                    });

                    $(window).on("unload", function () {
                        $(window).off("beforeunload");
                    });
                    break;
                default:
                    //Notes effect only on: 1,2,3,5,6]
                    params.note = this.note;
            }
            params.status_id = this.status;
            params.open_time = this.open_time;

            promise.then(result => {
                if (result) {
                    if (params.terminal && params.is_stripe_terminal) {
                        return this._saveStatusStripeTerminal(params).then(
                            res => {
                                if (res && res.state === 1) {
                                    $(window).off("beforeunload");
                                    self._message(res.message, "warning");
                                    self.saving = false;
                                    self.loading = false;
                                    self.cancelling = false;
                                }
                            }
                        );
                    }

                    if (params.is_stripe_keyed_in) {
                        $(window).off("beforeunload");
                        self.saving = false;
                        self.loading = false;
                        self.cancelling = false;
                        return;
                    }

                    return this._saveStatus(params)
                        .then(async function (responseSave) {
                            const { response, admitResponse } = responseSave;

                            if (response && response.state === 0) {
                                self.$refs.statusModal.hide();

                                // Print checkout docs
                                if (response.document_uri) {
                                    map(response.document_uri, document => {
                                        self._redirect(document, true);
                                    });
                                }
                                if (self.refreshAll) {
                                    self.$parent.refetch();
                                }
                                self.$emit(
                                    "update-scroll-y",
                                    self.currentScrollY
                                );

                                // Emit socket to refresh census
                                const payload = {
                                    appointmentDate: self
                                        ._toDateTime(
                                            self.appointment_data?.start
                                        )
                                        .toSeconds(),
                                    appointmentId: self.appointment_data?.id,
                                    instanceId: self.instanceId
                                };

                                self.refreshCensus(payload);

                                if (
                                    parseFloat(params.payment_amount) > 0 &&
                                    params.status_id === 7 &&
                                    Array.isArray(params.invoices) &&
                                    params.invoices.length > 0
                                ) {
                                    self.emitSocketInvoicePaid(params.invoices);
                                }

                                // VET-2428 : (census) The response from ci has the message "Appointment successfully checked in"
                                let message = response.message;
                                if (
                                    response.webform &&
                                    response.webform.message
                                ) {
                                    if (message.endsWith(".")) {
                                        message += response.webform.message;
                                    } else {
                                        message += `. ${response.webform.message}`;
                                    }
                                }
                                self._message(message);

                                // display antech immersed ui iframe
                                if (
                                    response.accession_id &&
                                    response.antech_token
                                ) {
                                    let labResponse = {};

                                    if (
                                        (response.lab_ids &&
                                            response.lab_ids.length > 0) ||
                                        response.idexx_lab_id
                                    ) {
                                        labResponse = await this.getLabIntegrationObject(
                                            response,
                                            "appointment"
                                        );
                                    }

                                    self.$root.$emit("call-antech-iframe", {
                                        antech_token: response.antech_token,
                                        accession_id: response.accession_id,
                                        lab_response: labResponse
                                    });
                                } else if (
                                    (response.lab_ids &&
                                        response.lab_ids.length > 0) ||
                                    response.idexx_lab_id
                                ) {
                                    let print_lab_params = {
                                        idexx_lab_id: response.idexx_lab_id,
                                        idexx_url: response.idexx_url,
                                        lab_ids: response.lab_ids,
                                        source: response.lab_source,
                                        module: "appointment"
                                    };

                                    self._print_lab_order(
                                        print_lab_params
                                    ).then(function (lab_response) {
                                        if (lab_response.idexx_iframe) {
                                            //load idexx iframe
                                            self.$root.$emit(
                                                "call_idexx_iframe",
                                                lab_response
                                            );
                                        } else {
                                            //load requisition form modal
                                            self.$root.$emit(
                                                "call-multirequsition-modal",
                                                lab_response
                                            );
                                        }
                                    });
                                }

                                // Handle admit response to start treatment
                                if (
                                    admitResponse &&
                                    self.isStartTreatment &&
                                    admitResponse.data &&
                                    admitResponse.data.response &&
                                    admitResponse.data.response.message.code ==
                                        200 &&
                                    admitResponse.data.response.resources
                                ) {
                                    /* Update start_treatment_data
                                    Construct data to pass on startTreatment component*/
                                    self.createStartTreatmentObject(
                                        response,
                                        admitResponse.data.response.resources
                                    );

                                    self.$nextTick(() => {
                                        self.$refs.startTreatment.open(
                                            self.start_treatment_data
                                        );
                                    });
                                }
                            } else {
                                self._message(responseSave.message, "warning");
                                self.isProcessing = false;
                                self.closePaymentProcessingMessage();
                            }
                        })
                        .finally(() => {
                            $(window).off("beforeunload");
                            self.saving = false;
                            self.loading = false;
                            self.cancelling = false;
                            self.isProcessing = false;
                            self.closePaymentProcessingMessage();

                            if (self.currentScrollY) {
                                window.scrollTo(
                                    0,
                                    parseInt(self.currentScrollY, 10)
                                );
                            }
                        });
                } else {
                    self.saving = false;
                    self.loading = false;
                    self.isProcessing = false;
                    self.closePaymentProcessingMessage();
                }
            });
        },
        verifyGravityPayment() {
            let self = this;

            var gravityData = {
                uniqueTransId: self.checkout_data.uniqueTransId,
                externalTransactionId: self.checkout_data.externalTransactionId
            };

            self.$http
                .post(process.env.BARRAMUNDI + "payment/verify-transaction", {
                    gravityData: gravityData
                })
                .then(function (response) {
                    if (response.data.response.success) {
                        self.saveCreditCard();
                    } else {
                        self._message(
                            "Payment failed. Please try again.",
                            "danger"
                        );
                        self.$refs.payment.callGravityIFrame(
                            self.checkout_data.gravity_button
                        );
                    }
                });
        },
        cancelOperation() {
            let self = this;
            self.cancelling = true;

            self.$http
                .post(process.env.BARRAMUNDI + "payment/cancel-operation", {
                    hsn: self.checkout_data.terminal,
                    payment_type: "Credit Card On Terminal (Gravity)"
                })
                .then(function (response) {
                    /*if (response.data.response.message.code == 200) {
                        self._message(
                            response.data.response.message.description
                        );
                    } else {
                        self._message(
                            response.data.response.message.description,
                            "danger"
                        );
                    }*/

                    self.loading = false;
                    self.saving = false;
                    self.cancelling = false;
                });
        },
        cancelStripeCollectionStatus(stripeTerminal) {
            this.stripeTerminal = stripeTerminal;
        },
        capturingStripeTerminalStatus() {
            this.stripeTerminal = null;
            this.cancelling = false;
        },
        resetStripeTerminal() {
            // this.stripeTerminal.cancelCollectPaymentMethod();
            this.cancelling = true;
            this._cancelStripeTerminal(this.stripeTerminal);
            this.stripeTerminal = null;
        },
        createStartTreatmentObject(response, admitResponse) {
            if (response && response.triage && admitResponse) {
                admitResponse.active_triage = response.triage;
            }

            this.start_treatment_data = {
                patient: admitResponse.patient,
                treatment: admitResponse, // Updated admitResponse with active_triage
                clientID: admitResponse.client_id,
                treatmentID: admitResponse.id
            };
        },
        disabledSaveButton(isDisabled) {
            let self = this;
            if (isDisabled) {
                self.isDisabledButton = true;
            } else {
                self.isDisabledButton = false;
            }
        }
    }
};
</script>
